import React from "react";
import { NormalMessage, NormalMessageProps } from "./normal-message";
import { renderContentProps } from "./types";

type Props = Pick<renderContentProps, "originalMessage"> & NormalMessageProps;
export const TtComment = (props: Props): JSX.Element => {
  const message = props.message || "";
  return <NormalMessage {...props} message={message} />;
};
